<script>
import { hotelStayFactors as _API_ } from "./api-calls";
import { locationHelper } from "./api-calls";

export default {
    data() {
        return {
            countries: [],

            EMPTY_STATE_OBJECT: {
                add_state_id: null,
                add_state_name: ''
            },

            data: [],

            headers: [
                {
                    key: '#',
                    in: 'index',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    }
                },
                {
                    key: 'country_name',
                    in: 'country_name',
                    style: {
                        'flex': 3,
                        'text-align': 'center'
                    }
                },
                {
                    key: 'state_name',
                    in: 'state_name',
                    style: {
                        'flex': 3,
                        'text-align': 'left'
                    }
                },
                {
                    key: 'hotel_stay_factor_value',
                    in: 'main_data',
                    style: {
                        'flex': 1,
                        'text-align': 'center'
                    }
                },
                {
                    key: 'published_year',
                    in: 'main_data',
                    style: {
                        'flex': 2,
                        'text-align': 'center'
                    }
                },
                {
                    key: 'data_source',
                    in: 'main_data',
                    style: {
                        'flex': 4,
                        'text-align': 'center'
                    }
                },
            ],

            createData: undefined,
            editData: undefined,
        }
    },

    computed: {
        createDataStates() {
            if (this.createData && this.createData.main_data.country && this.createData.main_data.country.has_state) {
                return this.createData.main_data.country.states;
            }

            return [];
        }
    },

    async mounted() {
        await this.fetchCountry();
        await this.fetchRequest();
    },

    methods: {
        async fetchCountry() {
            await locationHelper.fetch()
                .then(res => {
                    this.countries = res.data;
                });
        },

        async fetchRequest() {
            await _API_.fetch()
                .then(res => {
                    this.data = res.data;
                })
        },
        
        async createRequest() {
            const params = {
                id: undefined,
                body: this.createData
            };

            if (params.body.main_data.country.has_state == false) {
                params.body.main_data.state = null;
            }

            await _API_.create(params)
                .then(res => {
                    this.data.push(
                        {
                            main_data: {
                                id: res.data.value,
                                created_by: this.$user.user_id,
                                created_on: new Date(),
                                ...this.createData.main_data
                            },
                            country_name: params.body.main_data.country.add_country_name,
                            state_name: params.body.main_data.state ? params.body.main_data.state.add_state_name : ''
                        }
                    );

                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },
        
        async updateRequest() {
            const params = {
                id: this.editData.main_data.id,
                body: this.editData
            };
            await _API_.update(params)
                .then(res => {
                    this.editData.updated_by = this.$user.user_id,
                    this.editData.updated_on = new Date(),
                    this.editData.country_name = params.body.main_data.country.add_country_name;
                    this.editData.state_name = params.body.main_data.state ? params.body.main_data.state.add_state_name : '';
                    this.editData.main_data.country_id = params.body.main_data.country.add_country_id;
                    this.editData.main_data.state_id = params.body.main_data.state ? params.body.main_data.state.add_state_id : null;
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },
        
        async deleteRequest() {
            const params = {
                id: this.editData.main_data.id,
                body: undefined
            };
            await _API_.delete(params.id)
                .then(res => {
                    this.editData.main_data.is_deleted = true;
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
                .finally(() => {
                    this.$refs.editPopup.startHideProcess();
                })
        },

        async handleClickCreate() {
            await this.setupCreateData();
            this.$refs.createPopup.openPopup();
        },

        async setupCreateData() {
            this.createData = {
                main_data: {
                    country: null,
                    state: null,
                    hotel_stay_factor_value: null,
                    published_year: null,
                    data_source: null
                }
            };
        },

        async handleClickEdit(item) {
            await this.setupEditData(item);
            this.$refs.editPopup.openPopup();
        },

        async setupEditData(item) {
            this.editData = item;

            if (this.editData.main_data.country_id) {
                await Object.assign(
                    this.editData.main_data,
                    {
                        country: this.countries.find(c => c.add_country_id === this.editData.main_data.country_id)
                    }
                );

                if (this.editData.main_data.country.has_state && this.editData.main_data.state_id) {
                    await Object.assign(
                        this.editData.main_data,
                        {
                            state: this.editData.main_data.country.states.find(s => s.add_state_id === this.editData.main_data.state_id)
                        }
                    );
                }
            }
        },
    }
}
</script>

<template>
    <div class="flex-all-centered-col main-frame">
        <div class="table small-box-shadow">
            <div class="table-row headers">
                <div v-for="h in headers" :key="h.key"
                    :style="h.style"
                >
                    {{ $t(`carbon-admin.headers.${h.key}`) }}
                </div>
            </div>
    
            <div v-for="(item, idx) in data" :key="idx"
                v-show="!item.main_data.is_deleted"
                class="table-row values"
                @click="handleClickEdit(item)"
            >
                <div v-for="h in headers" :key="h.key"
                    :style="h.style"
                >
                    <span v-if="h.in === 'index'">
                        {{ idx+1 }}
                    </span>
                    <span v-else-if="h.in === 'country_name' || h.in === 'state_name'">
                        {{ item[h.in] }}
                    </span>
                    <span v-else>
                        {{ item.main_data[h.key] }}
                    </span>
                </div>
            </div>
        </div>

        <div class="flex-all-centered-row" style="justify-content: flex-end;">
            <button class="sust-btn sust-btn-green"
                @click="handleClickCreate()"
            >
                {{ $t('misc.create-new') }}
            </button>
        </div>

        <sust-popup ref="createPopup"
            size="md"
            :header="false"
            @ok="createRequest()"
            @onHide="() => createData = undefined"
        >
            <div v-if="createData" 
                class="flex-all-centered-col"
            >
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.country_name') }}
                    </div>
                    <select class="sust-input-field" 
                        style="width: 100%; text-align: center;"
                        type="text" 
                        v-model="createData.main_data.country"
                    >
                        <option v-for="item in countries"
                            :value="item"
                            :key="item.add_country_id"
                        >
                            {{ item.add_country_name }}
                        </option>
                    </select>
                </div>
                <div v-if="createDataStates.length > 0"
                    class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.state_name') }}
                    </div>
                    <select class="sust-input-field" 
                        style="width: 100%; text-align: center;"
                        type="text" 
                        v-model="createData.main_data.state"
                    >
                        <option v-for="item in [EMPTY_STATE_OBJECT, ...createDataStates]"
                            :value="item"
                            :key="item.add_state_id"
                        >
                            {{ item.add_state_name }}
                        </option>
                    </select>
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.hotel_stay_factor_value') }}
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%; text-align: center;"
                        type="number" 
                        v-model="createData.main_data.hotel_stay_factor_value"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.published_year') }}
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%; text-align: center;"
                        type="number" 
                        v-model="createData.main_data.published_year"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.data_source') }}
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="createData.main_data.data_source"
                    >
                </div>
            </div>
        </sust-popup>
        
        <sust-popup ref="editPopup"
            size="md"
            :header="false"
            @ok="updateRequest()"
            @onHide="() => editData = undefined"
        >
            <div v-if="editData" 
                class="flex-all-centered-col"
            >
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.country_name') }}
                    </div>
                    <select class="sust-input-field" 
                        style="width: 100%; text-align: center;"
                        type="text" 
                        v-model="editData.main_data.country"
                    >
                        <option v-for="item in countries"
                            :value="item"
                            :key="item.add_country_id"
                        >
                            {{ item.add_country_name }}
                        </option>
                    </select>
                </div>
                <div v-if="editData.main_data.country.has_state"
                    class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.state_name') }}
                    </div>
                    <select class="sust-input-field" 
                        style="width: 100%; text-align: center;"
                        type="text" 
                        v-model="editData.main_data.state"
                    >
                        <option v-for="item in [EMPTY_STATE_OBJECT, ...editData.main_data.country.states]"
                            :value="item"
                            :key="item.add_state_id"
                        >
                            {{ item.add_state_name }}
                        </option>
                    </select>
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.hotel_stay_factor_value') }}
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%; text-align: center;"
                        type="number" 
                        v-model="editData.main_data.hotel_stay_factor_value"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.published_year') }}
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%; text-align: center;"
                        type="number" 
                        v-model="editData.main_data.published_year"
                    >
                </div>
                <div class="flex-all-centered-col"
                    style="margin: .35em 0;"
                >
                    <div style="font-weight: bold;">
                        {{ $t('carbon-admin.headers.data_source') }}
                    </div>
                    <input class="sust-input-field" 
                        style="width: 100%;"
                        type="text" 
                        v-model="editData.main_data.data_source"
                    >
                </div>
            </div>

            <template #footer="{ hide }">
                <div class="flex-all-centered-row"
                    style="justify-content: space-between; padding: .5em;"
                >
                    <button class="sust-btn sust-btn-red"
                        @click="() => {
                            $refs.deletePopup.openPopup()
                        }"
                    >
                        {{ $t('misc.delete') }}
                    </button>

                    <div class="flex-all-centered-row"
                        style="justify-content: flex-end;"
                    >
                        <button class="sust-btn sust-btn-red"
                            @click="hide()"
                        >
                            {{ $t('misc.cancel') }}
                        </button>
                        <button class="sust-btn sust-btn-green"
                            style="margin-left: 1em;"
                            @click="() => {
                                updateRequest(); 
                                hide();
                            }"
                        >
                            {{ $t('misc.save') }}
                        </button>
                    </div>
                </div>
            </template>
        </sust-popup>

        <sust-popup ref="deletePopup"
            size="sm"
            :title="$t('carbon-admin.titles.delete')"
            @ok="deleteRequest()"
        >
            {{ $t('carbon-admin.warnings.delete') }}
        </sust-popup>
    </div>
</template>

<style lang='scss' scoped>
@import "../../../assets/css/carbon-admin-page.scss";
</style>